import { useCallback } from 'react';
import { getContractFromRoleId } from './contractHelper';
import { useContracts } from './useContracts';

export const useGetContractFromRole = () => {
  const { contracts } = useContracts();

  return useCallback(
    (contractRoleId: string) => {
      return getContractFromRoleId(contracts, contractRoleId);
    },
    [contracts]
  );
};
